import { render, staticRenderFns } from "./Pedidos2.vue?vue&type=template&id=532c6194"
import script from "./Pedidos2.vue?vue&type=script&lang=js"
export * from "./Pedidos2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports